import cn from 'classnames'
import { TextInputVariant } from 'ext-ui/components/TextInput/TextInput'
import React, { ComponentProps, forwardRef } from 'react'

import styles from './TextInputInternal.style'

type TextInputProps = ComponentProps<'input'> & {
  variant: TextInputVariant
}

const TextInputInternal = forwardRef<HTMLInputElement, TextInputProps>(
  (props, ref) => {
    const { variant, className, disabled, readOnly, value, ...rest } = props
    return (
      <input
        css={styles}
        className={cn(className, variant)}
        disabled={disabled}
        value={value}
        readOnly={readOnly}
        {...rest}
        ref={ref}
      />
    )
  },
)

export default TextInputInternal
